import {
  CustomButtonProps,
  CustomButtonVariant,
} from "../../../components/CustomButton/CustomButton";
import { applyVolumeMask } from "../../../utils";
import { convertToDefaultDate } from "../../../utils/dateFormatter";
import { Action, State } from "./schema";

interface Options {
  label: string;
  state: string | null;
  setState: Action["type"];
  list: Array<{ id: string; description: string }>;
  field: string;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class ComponentFactory {
  static getRowsItems(data: State, name: string) {
    return [
      { label: "Nome da razão social", data: data.client },
      { label: "Filial", data: data.codeSubsidiary },
      {
        label: "Solicitado por",
        data: name,
      },
      {
        label: "Data para bombeio",
        data: convertToDefaultDate(data.date ?? ""),
      },
      { label: "Horário", data: data.time },
      { label: "Nome do produto", data: data.product },
      { label: "Modalidade", data: data.modality },
      { label: "Quantidade", data: applyVolumeMask(String(data.quantity)) },
      { label: "Nota Fiscal-Serie", data: data.invoice },
    ];
  }

  static getActionButtons(
    loading: boolean,
    actions: VoidFunction[]
  ): CustomButtonProps[] {
    const baseComponents: CustomButtonProps[] = [
      {
        title: "Cancelar",
        variant: CustomButtonVariant.OUTLINED,
      },
      {
        title: "Confirmar solicitação",
        variant: loading
          ? CustomButtonVariant.CONTAINED_LOADING
          : CustomButtonVariant.CONTAINED,
      },
    ];

    return baseComponents.map((items, index) => ({
      ...items,
      onClick: actions[index],
    }));
  }

  static getFieldOptions(
    isDischarge: boolean,
    state: State,
    list: Array<Options["list"]>
  ): Options[] {
    const baseComponents = [
      {
        label: isDischarge ? "Cliente" : "Nome do cliente",
        state: state.client,
        setState: "set-client",
        field: "client",
      },
      {
        label: "Filial",
        state: state.codeSubsidiary,
        setState: "set-code-subsidiary",
        field: "codeSubsidiary",
      },
      {
        label: "Contrato",
        state: state.contract,
        setState: "set-contract",
        field: "contract",
      },
      {
        label: "Produto",
        state: state.product,
        setState: "set-product",
        field: "product",
      },
      {
        label: "Modalidade",
        state: state.modality,
        setState: "set-modality",
        field: "modality",
      },
    ] as const;

    return baseComponents.map((item, index) => ({
      ...item,
      list: list[index],
    }));
  }
}
